import React from 'react';
import './UKUniversities.css';

const universities = {
  A: [
    "American University in Dubai (AUD)",
    "Amity University Dubai",
    "Al Ghurair University",
    "American University in the Emirates (AUE)",
  ],
  B: [
    "BITS Pilani Dubai Campus",
    "Birla Institute of Technology - Dubai",
    "British University in Dubai (BUiD)",
  ],
  C: [
    "Canadian University Dubai",
    "Curtin University Dubai",
  ],
  E: [
    "Emirates Aviation University",
    "Esmod French Fashion Institute Dubai",
  ],
  H: [
    "Heriot-Watt University Dubai",
    "Hamdan Bin Mohammed Smart University",
  ],
  M: [
    "Manipal Academy of Higher Education Dubai",
    "Middlesex University Dubai",
    "Mohammed Bin Rashid University of Medicine and Health Sciences (MBRU)",
  ],
  R: [
    "Rochester Institute of Technology (RIT) Dubai",
  ],
  S: [
    "SP Jain School of Global Management",
    "Synergy University Dubai",
  ],
  U: [
    "University of Dubai",
    "University of Wollongong in Dubai (UOWD)",
    "University of Birmingham Dubai",
  ],
  W: [
    "Westford University College",
  ]
};

const DubaiUniversities = () => {
  return (
    <div className="uk-container">
      <h2 className="uk-title">Dubai Universities</h2>
      <table className="uk-table">
        <thead>
          <tr>
            <th>Letter</th>
            <th>University Name</th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(universities).map(([letter, uniList]) =>
            uniList.map((uni, idx) => (
              <tr key={`${letter}-${idx}`}>
                <td>{idx === 0 ? letter : ''}</td>
                <td>{uni}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default DubaiUniversities;
